import { Directive, ElementRef, Input } from "@angular/core";
import { NativeDesktopSupport } from "./native-desktop-support";

// Note this must not be used with class="{{interpolation}}"
// as template interpolation will remove any set nativeDesktopClass

@Directive({
  selector: "[nativeDesktopClass]",
  standalone: false,
})
export class NativeDesktopClass {
  private element: ElementRef;

  constructor(element: ElementRef) {
    this.element = element;
  }

  @Input("nativeDesktopClass")
  set value(value: string) {
    NativeDesktopSupport.initializationSubject.subscribe(
      (() => {
        this.element.nativeElement.classList.add(value);
      }).bind(this),
    );
  }
}
